module.exports = __webpack_public_path__ + "images/f4440a0c4272c4d155c31a9d4b725aed.svg";